import { createTheme, darken } from "@mui/material/styles"

import drawerBg from "../src/static/images/drawer--background-v4.png"
import GlassMixin, {
  BaseGlassMixin,
  GlassMixinVariant1,
} from "./common/components/GlassMixin"

const SS_PURPLE = "#9320D5"
const SS_PINK = "#ff00d3"
const LIGHT_BACKGROUND = "#F5F6FA"

export default createTheme({
  palette: {
    primary: {
      main: SS_PURPLE,
      light: "#892FCE",
      dark: "#4A1B65",
    },
    secondary: {
      main: SS_PINK,
    },
    success: {
      main: "#079455",
    },
    error: {
      main: "#D92D20",
    },
    text: {
      primary: "#0a2540",
      secondary: "#2b3742",
      purple: "#7728A4",
      pink: SS_PINK,
    },
    colors: {
      purple: SS_PURPLE,
      pink: SS_PINK,
      brand50: "#FBF3FF",
      brand100: "#F6E9FE",
      brand200: "#EFD6FE",
      brand400: "#D386FF",
      brand500: "#9525D6",
      brand600: "#9320D5",
      brand700: "#7728A4",
      success50: "#ECFDF3",
      success200: "#ABEFC6",
      success500: "#17B26A",
      success600: "#079455",
      success700: "#067647",
      error50: "#FEF3F2",
      error600: "#D92D20",
      error700: "#B42318",
      gray50: "#F9FAFB",
      gray100: "#F2F4F7",
      gray200: "#EAECF0",
      gray300: "#D0D5DD",
      gray400: "#98A2B3",
      gray500: "#667085",
      gray600: "#475467",
      gray700: "#344054",
      gray800: "#182230",
      gray900: "#101828",
      lightBackground: LIGHT_BACKGROUND,
      dimLightBackground: darken(LIGHT_BACKGROUND),
      dimBackground: "#f9fbfd",
      dimmedText1: "#999fac",
      dimmedText2: "#9ca3af",
    },
  },
  typography: {
    fontFamily: "Inter, sans-serif",
    fontOpticalSizing: "auto",
    fontWeight: 400,
    fontStyle: "normal",
    fontVariationSettings: "'slnt' 0",
  },
  shadows: {
    0: "none",
    1: "0px 12px 16px -4px #10182814",
    2: "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
    3: "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)",
    4: "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
    5: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
    6: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
    7: "0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)",
    8: "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
    9: "0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)",
    10: "0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)",
    11: "0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)",
    12: "0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)",
    13: "0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)",
    14: "0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)",
    15: "0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)",
    16: "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
    17: "0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)",
    18: "0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)",
    19: "0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)",
    20: "0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)",
    21: "0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)",
    22: "0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)",
    23: "0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)",
    24: "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)",
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        h1: {
          fontSize: "30px",
          fontWeight: 700,
        },
        h2: {
          fontSize: "24px",
          fontWeight: 600,
        },
        h3: {
          fontSize: "20px",
          fontWeight: 600,
        },
        h4: {
          fontSize: "18px",
          fontWeight: 600,
        },
        h5: {
          fontSize: "16px",
          fontWeight: 600,
        },
        h6: {
          fontSize: "14px",
          fontWeight: 500,
        },
        paragraph: {
          fontSize: "15px",
          fontWeight: 400,
        },
        body1: {
          fontSize: "14px",
          fontWeight: 400,
        },
      },
      variants: [
        {
          props: { variant: "strong-inline" },
          style: {
            fontWeight: 600,
            fontSize: "inherit",
          },
        },
      ],
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          background: "transparent",
          paddingInline: "6px",
          fontSize: "0.9rem",
          fontWeight: 400,
          "&.MuiInputLabel-shrink": {
            background: BaseGlassMixin.background,
            border: "1px solid rgba(255, 255, 255, 0.9)",
            borderRadius: "8px",
            left: "-4px",
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        labelPlacementStart: ({ theme }) => ({
          "& .MuiFormControlLabel-label": {
            marginRight: theme.spacing(1),
          },
        }),
        labelPlacementTop: ({ theme }) => ({
          marginInline: 0,
          "& .MuiFormControlLabel-label": {
            marginBottom: theme.spacing(1),
          },
        }),
      },
    },
    MuiButton: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: ({ theme }) => ({
          fontWeight: 600,
          textTransform: "none",
          borderRadius: "24px",
          transition: theme.transitions.create(
            ["color", "background-color", "box-shadow"],
            { duration: 150, easing: "ease-in-out" }
          ),
          textWrap: "nowrap",
          minWidth: "min-content",
          "&.Mui-disabled": {
            opacity: 0.65,
          },
          "&.Mui-disabled .MuiSvgIcon-root": {
            color: theme.palette.colors.gray300,
          },
        }),
        sizeSmall: ({ theme }) => ({
          paddingBlock: "6px",
          paddingInline: "14px",
          fontSize: "14px",
        }),
        sizeMedium: {
          paddingInline: "14px",
          paddingBlock: "10px",
        },
        colorPrimary: ({ theme }) => ({
          "& .MuiSvgIcon-root": {
            color: theme.palette.primary.brand700,
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          },
        }),
        outlinedInherit: ({ theme }) => ({
          color: theme.palette.colors.gray700,
          background: "rgb(219 208 228 / 40%)",
          border: "1px solid rgba(219, 208, 228, 0.9)",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          "& .MuiSvgIcon-root": {
            color: theme.palette.colors.gray700,
          },
        }),
        outlinedPrimary: ({ theme }) => ({
          "& .MuiSvgIcon-root": {
            color: theme.palette.colors.brand700,
          },
        }),
        contained: {
          boxShadow: "none",
          "& .MuiSvgIcon-root": {
            color: "white",
          },
        },
        containedPrimary: ({ theme }) => ({
          color: "white",
          "&.Mui-disabled": {
            opacity: 0.65,
            color: "white",
          },
        }),
      },
    },
    MuiButtonGroup: {
      styleOverrides: {
        background: "transparent",
        padding: "0x",
        groupedOutlined: ({ theme }) => ({
          border: "1px solid rgba(255, 255, 255, 0.8)",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 4px",
          background: "rgba(255, 255, 255, 0.3)",
          "&.active": {
            background: "rgba(255, 255, 255, 0.6)",
            backdropFilter: "blur(4px)",
          },
        }),
      },
    },
    MuiIconButton: {
      defaultProps: {
        disableRipple: false,
        color: "primary",
      },
      variants: [
        {
          props: { variant: "bordered" },
          style: ({ theme }) => ({
            border: `1px solid ${theme.palette.colors.gray300}`,
            borderRadius: "8px",
            padding: "10px",
            "& .MuiSvgIcon-root": {
              color: theme.palette.colors.gray700,
            },
          }),
        },
      ],
    },
    MuiFab: {
      styleOverrides: {
        primary: ({ theme }) => ({
          "& .MuiSvgIcon-root": {
            color: "white",
          },
        }),
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          "::placeholder": {
            color: "#000",
            opacity: 1,
          },

          /* 🔹 Chrome / Edge autofill */
          "&:-webkit-autofill": {
            WebkitBoxShadow: "none",
            WebkitTextFillColor: "#06153d",
            caretColor: "#06153d",
            transition: "background-color 9999s ease-in-out 0s",
          },

          "&:-webkit-autofill:hover": {
            WebkitTextFillColor: "#06153d",
          },

          "&:-webkit-autofill:focus": {
            WebkitTextFillColor: "#06153d",
          },
        },
        root: {
          borderRadius: "24px",
          /* correct focus selector */
          "&.Mui-focused": {
            color: "#06153d",
          },
          "& .MuiSvgIcon-root": {
            zIndex: 2,
          },
          "& .MuiButtonBase-root": {
            zIndex: 2,
          },
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          zIndex: 2,
          fontSize: "0.9rem",
        },
        notchedOutline: ({ theme }) => ({
          borderRadius: "24px",
          border: "1px solid rgba(255, 255, 255, 0.80)",
          background:
            "linear-gradient(104deg, rgba(255, 255, 255, 0.80) 3.49%, rgba(255, 255, 255, 0.39) 99.42%)",
          boxShadow:
            "0 20px 25px -5px rgba(245, 218, 255, 0.10), 0 8px 10px -6px rgba(52, 64, 84, 0.10)",
        }),
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: ({ theme }) => ({
          transition: theme.transitions.create(["border-color", "box-shadow"], {
            duration: 150,
            easing: "ease-in-out",
          }),
        }),
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          padding: "16px",
          borderRadius: "16px",
          ...GlassMixin,
          "&.MuiCard-root": {
            background:
              "linear-gradient(159deg, rgba(255, 255, 255, 0.8) 3.01%, rgba(255, 255, 255, 0.4) 103.3%)",
            backdropFilter: "blur(21px)",
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 12px",
          },
          "& .MuiCardContent-root": {
            padding: "0px !important",
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        popper: {
          "& .MuiPaper-root.MuiAutocomplete-paper": {
            padding: "8px",
            borderRadius: "24px",
            ...GlassMixin,
          },
          "& .MuiAutocomplete-listbox > li": {
            borderRadius: "32px",
            background: "transparent",
          },
        },
      },
    },

    MuiPopover: {
      styleOverrides: {
        paper: {
          padding: "0px",
          borderRadius: "24px",
          ...GlassMixin,
          "& .MuiBox-root": {
            background: "rgba(255, 255, 255, 0)",
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          width: "614px",
          padding: "0px",
          borderRadius: "16px",
          ...GlassMixin,
          "& > .MuiBox-root": {
            background:
              "linear-gradient(159deg, rgba(255, 255, 255, 0.4) 3.01%, rgba(255, 255, 255, 0.25) 103.3%)",
          },
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: ({ theme }) => ({
          padding: theme.spacing(3),
          [theme.breakpoints.only("xs")]: {
            padding: theme.spacing(2),
          },
        }),
      },
    },
    MuiDialogActions: {
      variants: [
        {
          props: { variant: "balanced" },
          style: ({ theme }) => ({
            justifyContent: "flex-start",
            "& > .MuiButtonBase-root, & > .MuiButtonGroup-root": {
              flexBasis: "50%",
            },
          }),
        },
      ],
      styleOverrides: {
        root: ({ theme }) => ({
          paddingInline: theme.spacing(3),
          paddingBlock: theme.spacing(3),
          borderTop: "2px solid rgba(0, 0, 0, 0.1)",
          [theme.breakpoints.only("xs")]: {
            paddingInline: theme.spacing(2),
          },
        }),
      },
    },
    MuiDrawer: {
      styleOverrides: {
        root: ({ theme }) => ({
          "& > .MuiPaper-root": {
            width: "614px",
            padding: "0px",
            borderRadius: "16px",
            backgroundImage: `url(${drawerBg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            border: "none",
            [theme.breakpoints.only("xs")]: {
              width: "100%",
            },

            "& > .MuiBox-root": {
              background: "#eae8ed",
              boxShadow: "0 20px 40px 0 rgba(0, 0, 0, 0.1)",
              backdropFilter: "blur(10px)",
            },
            "& .MuiDialogActions-root": {
              borderTop: "1px solid rgba(255, 255, 255, 0.80)",
            },

            "& .MuiPaper-elevation .MuiPaper-elevation": {
              borderRadius: "16px",
              border: "1px solid rgba(255, 255, 255, 0.80)",
              background:
                "linear-gradient(104deg, rgba(255, 255, 255, 0.80) 3.49%, rgba(255, 255, 255, 0.39) 99.42%)",
              boxShadow:
                "0 20px 25px -5px rgba(245, 218, 255, 0.10), 0 8px 10px -6px rgba(52, 64, 84, 0.10)",
              "&:before": {
                display: "none",
              },
              "& .MuiPaper-root": {
                padding: "0px",
                borderRadius: "8px",
                border: "1px solid rgba(255, 255, 255, 0.80)",
                background:
                  "linear-gradient(104deg, rgba(255, 255, 255, 0.60) 3.49%, rgba(255, 255, 255, 0.39) 99.42%)",
                boxShadow:
                  "0 20px 25px -5px rgba(245, 218, 255, 0.10), 0 8px 10px -6px rgba(74, 69, 75, 0.10)",
              },
            },
          },
        }),
      },
    },
    MuiSwipeableDrawer: {
      styleOverrides: {
        paper: ({ theme }) => ({
          borderRadius: "0px 16px 16px 0px",
          ...GlassMixin,
          boxShadow: "0 12px 45px rgba(0, 0, 0, 0.15)",
          "& > .MuiBox-root": {
            background: "rgba(255, 255, 255, 0)",
            borderRadius: "0px 16px 16px 0px",
          },
        }),
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.text.secondary,
          fontWeight: 600,
          backgroundColor: theme.palette.colors.gray100,
        }),
      },
    },
    MuiChip: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: "16px",
          ...BaseGlassMixin,
          color: theme.palette.colors.brand700,
        }),
        sizeMedium: ({ theme }) => ({
          height: "28px",
        }),
        outlinedPrimary: ({ theme }) => ({
          borderRadius: "16px",
          color: theme.palette.colors.brand700,
          ...GlassMixin,
        }),
        label: ({ theme }) => ({
          color: "#0f1216",
          fontWeight: 500,
        }),
        deleteIcon: {
          color: "#0f1216",
        },
      },
    },
    MuiLink: {
      defaultProps: {
        underline: "hover",
        color: "primary.main",
        lineHeight: 0,
      },
    },
    MuiSvgIcon: {
      defaultProps: {
        fontSize: "small",
      },
      variants: [
        {
          props: { variant: "g50" },
          style: ({ theme }) => ({
            color: theme.palette.colors.gray50,
          }),
        },
        {
          props: { variant: "g400" },
          style: ({ theme }) => ({
            color: theme.palette.colors.gray400,
          }),
        },
        {
          props: { variant: "g500" },
          style: ({ theme }) => ({
            color: theme.palette.colors.gray500,
          }),
        },
        {
          props: { variant: "g600" },
          style: ({ theme }) => ({
            color: theme.palette.colors.gray600,
          }),
        },
        {
          props: { variant: "b500" },
          style: ({ theme }) => ({
            color: theme.palette.colors.brand500,
          }),
        },
        {
          props: { variant: "b600" },
          style: ({ theme }) => ({
            color: theme.palette.colors.brand600,
          }),
        },
        {
          props: { variant: "b700" },
          style: ({ theme }) => ({
            color: theme.palette.colors.brand700,
          }),
        },
      ],
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.colors.gray500,
        }),
      },
    },
    MuiAlert: {
      styleOverrides: {
        filledSuccess: ({ theme }) => ({
          background: "#8b7ec0 !important",
          backdropFilter: "blur(0px)",
          "& .MuiSvgIcon-root": {
            color: "white",
          },
        }),
      },
    },
    MuiIcon: {
      styleOverrides: {
        colorAction: {
          color: "white",
        },
        colorPrimary: {
          color: "#475467",
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderColor: theme.palette.colors.gray200,
        }),
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: () => ({
          border: "none",
          "&:before": {
            display: "none",
          },
        }),
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderBottom: "none",
          height: "min-content",
          minHeight: 0,
          padding: 0,
          "&.Mui-expanded": {
            minHeight: 0,
            height: "min-content",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
            "&.Mui-expanded": {
              margin: 0,
            },
          },
        }),
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: ({ theme }) => ({
          paddingInline: 0,
          paddingBottom: 0,
          paddingTop: theme.spacing(2),
        }),
      },
    },
    MuiList: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: "16px",
          color: "#0a2540",
          ...GlassMixin,
        }),
        padding: {
          padding: "12px",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          minWidth: "120px",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: ({ theme }) => ({
          paddingInline: "10px",
          paddingBlock: "9px",
          borderRadius: "32px",
          lineHeight: 1,
          fontSize: "14px",
          fontWeight: 400,
          "&:hover": {
            color: theme.palette.colors.gray800,
            backgroundColor: theme.palette.colors.gray50,
          },
        }),
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: "15px",
          fontWeight: 500,
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: ({ theme }) => ({
          width: 36,
          height: 20,
          padding: 0,
          "& .MuiSwitch-switchBase": {
            padding: 0,
            margin: 2,
            transitionDuration: "300ms",
            "&.Mui-checked": {
              transform: "translateX(16px)",
              color: "#fff",
              "& + .MuiSwitch-track": {
                backgroundColor: theme.palette.colors.brand600,
                opacity: 1,
                border: 0,
              },
              "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.5,
              },
            },
            "&.Mui-focusVisible .MuiSwitch-thumb": {
              color: "#33cf4d",
              border: "6px solid #fff",
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
              color:
                theme.palette.mode === "light"
                  ? theme.palette.grey[100]
                  : theme.palette.grey[600],
            },
            "&.Mui-disabled + .MuiSwitch-track": {
              opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
            },
          },
          "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            width: 16,
            height: 16,
          },
          "& .MuiSwitch-track": {
            borderRadius: 9999,
            backgroundColor: theme.palette.colors.gray100,
            opacity: 1,
            transition: theme.transitions.create(["background-color"], {
              duration: 500,
            }),
          },
        }),
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        colorSecondary: ({ theme }) => ({
          color: theme.palette.colors.gray400,
        }),
      },
    },
    MuiSlider: {
      styleOverrides: {
        colorPrimary: ({ theme }) => ({
          "& .MuiSlider-thumb": {
            height: 24,
            width: 24,
            backgroundColor: "#fff",
            border: `1px solid ${theme.palette.colors.brand600}`,
            boxShadow: "0 0 2px 0px rgba(0, 0, 0, 0.1)",
            "&:focus, &:hover, &.Mui-active": {
              boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.1)",
            },
            "&:before": {
              boxShadow:
                "0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)",
            },
          },
          "& .MuiSlider-rail": {
            backgroundColor: theme.palette.colors.gray200,
          },
          "& .MuiSlider-valueLabel": {
            width: "32px",
            height: "32px",
            backgroundColor: "white",
            border: `1px solid ${theme.palette.colors.gray200}`,
            color: theme.palette.colors.gray700,
            boxShadow: "0px 4px 6px -2px #10182808",
            "&::before": {
              display: "none",
            },
          },
        }),
      },
    },
    MuiTable: {
      defaultProps: {
        stickyHeader: true,
      },
      styleOverrides: {
        root: {
          borderCollapse: "separate",
          borderSpacing: "0 4px",
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: GlassMixinVariant1,
      },
    },

    MuiTab: {
      defaultProps: {
        iconPosition: "start",
      },
      styleOverrides: {
        root: ({ theme }) => ({
          minHeight: 0,
          textTransform: "initial",
          "&.Mui-selected": {
            color: theme.palette.colors.brand500,
            "& .MuiSvgIcon-root": {
              fill: theme.palette.colors.brand500,
            },
          },
        }),
      },
    },
    MuiTabs: {
      defaultProps: {
        variant: "scrollable",
        scrollButtons: "auto",
      },
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: "transparent",
          borderBottom: "none",
          "& .MuiTabs-indicator": {
            backgroundColor: theme.palette.colors.brand900,
          },
        }),
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          overflowY: "auto !important",
          overflowX: "auto !important",
          marginTop: "24px",

          "& .MuiTable-root": {
            marginTop: "0px",
          },
          // Chrome/Safari hide
          "&::-webkit-scrollbar": {
            width: 0,
            height: 0, // IMPORTANT for X scrollbar
            transition: "all 0.3s",
          },
          // Show scrollbars on hover
          "&:hover::-webkit-scrollbar": {
            width: "6px",
            height: "6px", // Show horizontal scrollbar
          },
          "&:hover::-webkit-scrollbar-thumb": {
            borderRadius: "10px",
          },
        },
      },
    },
    MuiPickersPopper: {
      styleOverrides: {
        root: {
          "& .MuiPaper-root": {
            background:
              "linear-gradient(90deg, rgba(255, 255, 255, 0.8) 3.01%, rgba(255, 255, 255, 0.5) 103.3%)",
            padding: "0px 0px 16px 0px",
          },
          "& .MuiList-root": {
            background: "transparent",
            boxShadow: "none",
            borderRadius: "0px",
            "&::before": {
              display: "none",
            },
          },
          "& .MuiDialogActions-root": {
            padding: "16px 0 0",
          },
        },
      },
    },
    MuiPickersToolbar: {
      styleOverrides: {
        root: {
          "& .MuiButtonBase-root": {
            backgroundColor: "transparent",
            boxShadow: "none",
            borderRadius: "0px",
            "&::before": {
              display: "none",
            },
          },
          "& .MuiTimePickerToolbar-ampmSelection": {
            flexDirection: "inherit",
            gap: "8px",
            "& .MuiTypography-root": {
              color: "#ccc",
            },
            "& .Mui-selected": {
              color: "#9320D5",
            },
          },
        },
      },
    },
  },
})
